import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";
import { getPracticeId, patientPhotoUrl } from "../../config/practice";

const LowerExtremelyVennousDoppler = ({ ismodal, setIsmodal, data }) => {
  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const practiseid = getPracticeId();
  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const calculateAge = (dob) => dayjs().diff(dayjs(dob), "year");
  const age = calculateAge(data?.dob);
  const [providerList, setProviderList] = useState([]);
  const veins = ["HIV", "CFV", "GSV", "SFV", "SPV", "POPY", "POST T", "ANT T"];
const[isLoading,setIsLoading]=useState(false)
  const [formData, setFormData] = useState({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    history: "",
    techImpression: "",
    technologist: "",
    signature: "",
    veinTable: veins.reduce((acc, vein) => {
      acc[vein] = Array(12).fill("");
      return acc;
    }, {}),
  });
 useEffect(() => {
    if (ismodal) getProviders();
  }, [ismodal]);
useEffect(() => {
  if (!formData.provider && providerList.length > 0) {
    const providerNames = providerList.map(x => x.providername);

    if (data?.linked_provider && providerNames.includes(data.linked_provider)) {
      handleChange(null, "provider", data.linked_provider);
    } else if (providerList.length > 0) {
      handleChange(null, "provider", providerList[0].providername);
    }
  }
}, [providerList, data]);
  const getProviders = async () => {
    try {
      const response = await api.get(`/v1/${practiseid}/providers`);
      if (response.status === 200 && Array.isArray(response.data)) {
        setProviderList(response.data);
      }
    } catch (error) {
      setToastMessage("Failed to load providers");
      setToastSeverity("error");
      setOpenToast(true);
    }
  };
  const handleChange = (section, field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleTableChange = (vein, index, value) => {
    setFormData((prev) => ({
      ...prev,
      veinTable: {
        ...prev.veinTable,
        [vein]: prev.veinTable[vein].map((item, i) => (i === index ? value : item)),
      },
    }));
  };

  const validateForm = () => {
    const errors = [];
    if (!formData.provider) errors.push("Provider is required.");
    if (!formData.examDate) errors.push("Exam Date is required.");
    if (!formData.history.trim()) errors.push("Patient History is required.");
    if (!formData.techImpression.trim()) errors.push("Tech Impression is required.");
    if (!formData.technologist.trim()) errors.push("Technologist is required.");
    if (!formData.signature.trim()) errors.push("Signature is required.");
    return errors;
  };

  const handleSave = async() => {
    const errors = validateForm();
    if (errors.length > 0) {
      setToastMessage(errors[0]);
      setToastSeverity("error");
      setOpenToast(true);
    } else {
    const selectedProvider = providerList.find(
        (p) => p.providername === formData.provider
      );

      const patientDetails = {
        patientid: data.patientid,
        appointmentid: data.appointmentid,
        firstname: data.firstname,
        lastname: data.lastname,
        providername: formData.provider,
        providerid: selectedProvider?.providerid,
        pat_name: `${data?.firstname} ${data?.lastname}`,
          pat_dob: data?.dob,
        dob: formattedDOB,
        age,
        gender: data.gender === "M" ? "Male" : "Female",
      };
      let payload={...patientDetails,...formData}
try {
    setIsLoading(true)

     const user=await api.get('/auth/me')
          const [year, month, day] = formData.examDate.split("-");
          const formattedDate = `${month}/${day}/${year}`;
      
      const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
        "Worksheet_Type": "LOWER_EXTREMELY_VENOUS_DOPPLER",
        "createdby": user?.username || '',
        "appurl": window.location.origin,
          // "appurl": "https://api.prd.brainymed.com",
        "Exam_Date": formattedDate,
        "data":payload
      });
      
      if(response.status==200){
        const pdf=await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,{
        "filename": response?.data?.filename,      
        "worksheet_type":"LOWER_EXTREMELY_VENOUS_DOPPLER",
         "appurl": window.location.origin,
        "exam_date": formattedDate
        })
        setToastMessage("Form Submitted Successfully");
          setToastSeverity("success");
          setOpenToast(true);
          resetForm()
       setTimeout(() => {
    
        setIsmodal(false);
      }, 1000);
      
      }else{
        setToastMessage(response.message);
          setToastSeverity("info");
          setOpenToast(true);
      }
} catch (error) {
  console.log(error)
}finally{
setIsLoading(false)
}
    }
  };
const resetForm = () => {
    setFormData({
    provider: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    history: "",
    techImpression: "",
    technologist: "",
    signature: "",
    veinTable: veins.reduce((acc, vein) => {
      acc[vein] = Array(12).fill("");
      return acc;
    }, {}),
  })}
  if (!ismodal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">LOWER EXTREMELY VENOUS DOPPLER</h2>
          <button onClick={() => setIsmodal(false)} className="text-xl font-bold text-gray-500 hover:text-black">×</button>
        </div>
        <hr className="mb-4 border-gray-300" />

        <div className="flex items-center space-x-4 mb-4">
          <img
            src={patientPhotoUrl(data.patientid)}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
            <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
    #{data?.patientid}
            </div>
            <div className="text-base font-semibold">{data?.firstname + " " + data?.lastname}</div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Date of Birth:</span> {formattedDOB}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Age:</span> {age} | <span className="font-semibold">Gender:</span> {data?.gender === "M" ? "Male" : "Female"}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Providers</label>
              <select
              className="w-full border rounded px-2 py-1"
              value={formData.provider}
              onChange={(e) => handleChange(null, "provider", e.target.value)}
            >
              <option value="">Select Provider</option>
              {providerList.map((provider) => (
                <option key={provider.id} value={provider.providername}>
                  {provider.providername}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Exam Date</label>
            <input type="date" className="w-full border rounded px-2 py-1" value={formData.examDate} onChange={(e) => handleChange(null, "examDate", e.target.value)} />
          </div>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Patient History</label>
          <textarea placeholder="Enter Patient History here..." className="w-full border rounded px-2 py-1 mt-1" rows={3} value={formData.history} onChange={(e) => handleChange(null, "history", e.target.value)} />
        </div>

        <div className="overflow-auto mt-8">
          <table className="min-w-full border border-gray-300 text-center">
            <thead>
              <tr className="bg-gray-50 text-sm font-bold text-gray-700">
                <th className="border border-gray-300 px-2 py-1">#</th>
                <th colSpan="12" className="border border-gray-300 px-2 py-1">
                  Compression ultrasound / Color Flow / Possed Doppler
                </th>
              </tr>
              <tr className="text-xs bg-gray-50 text-gray-600 font-semibold">
                <th className="border border-gray-300 px-2 py-1"></th>
                <th colSpan="2" className="border border-gray-300 px-2 py-1">COMPRESSIBLE</th>
                <th colSpan="2" className="border border-gray-300 px-2 py-1">SPONTANEOUS</th>
                <th colSpan="2" className="border border-gray-300 px-2 py-1">PHASIC</th>
                <th colSpan="2" className="border border-gray-300 px-2 py-1">AUGMENT</th>
                <th colSpan="2" className="border border-gray-300 px-2 py-1">COMPETENT</th>
                <th colSpan="2" className="border border-gray-300 px-2 py-1">PULSATILE</th>
              </tr>
              <tr className="bg-gray-50 text-xs text-gray-600">
                <th className="border border-gray-300 px-2 py-1"></th>
                {Array(6).fill(null).map((_, index) => (
                  <React.Fragment key={index}>
                    <th className="border border-gray-300 px-2 py-1">R</th>
                    <th className="border border-gray-300 px-2 py-1">L</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            <tbody>
              {veins.map((vein) => (
                <tr key={vein} className="text-sm text-gray-800">
                  <td className="border border-gray-300 px-2 py-1 font-semibold">{vein}</td>
                  {formData.veinTable[vein].map((val, i) => (
                    <td key={i} className="border border-gray-300 px-2 py-1">
                      <input
                        type="text"
                        placeholder="Enter"
                        className="w-full px-1 py-1 border border-gray-200 rounded text-xs"
                        value={val}
                        onChange={(e) => handleTableChange(vein, i, e.target.value)}
                      />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-gray-50 text-gray-600 font-semibold text-sm">
                <td className="border border-gray-300 px-2 py-1"></td>
                <td colSpan={3} className="border border-gray-300 px-2 py-1">MINIMAL</td>
                <td colSpan={3} className="border border-gray-300 px-2 py-1">REDUCED</td>
                <td colSpan={3} className="border border-gray-300 px-2 py-1">ABNORMAL</td>
                <td colSpan={3} className="border border-gray-300 px-2 py-1">NOT ASSESSED</td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Tech Impression</label>
          <textarea className="w-full border rounded px-2 py-1 mt-1" rows={3} value={formData.techImpression} onChange={(e) => handleChange(null, "techImpression", e.target.value)} />
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Technologist</label>
          <input className="w-full border rounded px-2 py-1 mt-1" value={formData.technologist} onChange={(e) => handleChange(null, "technologist", e.target.value)} />
        </div>

        <div className="mt-4">
          <label className="block text-sm font-medium">Signature</label>
          <input className="w-full border rounded px-2 py-1 mt-1" placeholder="Signature" value={formData.signature} onChange={(e) => handleChange(null, "signature", e.target.value)} />
        </div>

        <div className="flex justify-end mt-6">
          <button onClick={handleSave} className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600">Save</button>
        </div>
      </div>
<Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
</Backdrop>
      <ToastMessage message={toastMessage} severity={toastSeverity} open={openToast} handleClose={() => setOpenToast(false)} />
    </div>
  );
};

export default LowerExtremelyVennousDoppler;
